/* ATOMIC badge builder engine — ported from ACC's production product builders.
   Reads config from <script type="application/json" data-builder-config> inside
   the section, renders the hero canvas, wires font chips / swatches / attract mode,
   and listens for font-strip tiles ([data-strip-font]) anywhere on the page. */
(function () {
  'use strict';

  /* ---- color library: exact values from the live product builders ---- */
  var F = {
    gloss_black:{t:'solid',c:[10,10,12]},matte_black:{t:'matte',c:[30,30,34]},gray:{t:'solid',c:[140,140,148]},white:{t:'solid',c:[245,245,248]},maroon:{t:'solid',c:[110,15,15]},red:{t:'solid',c:[220,15,15]},orange:{t:'solid',c:[240,130,10]},yellow:{t:'solid',c:[235,200,15]},lime_green:{t:'solid',c:[140,220,10]},green:{t:'solid',c:[10,170,40]},blue:{t:'solid',c:[20,60,200]},purple:{t:'solid',c:[120,15,190]},pink:{t:'solid',c:[240,110,170]},brown:{t:'solid',c:[75,35,20]},
    mirror_gold:{t:'mirror',c:[190,160,40]},mirror_silver:{t:'mirror',c:[190,195,200]},mirror_rosegold:{t:'mirror',c:[200,155,140]},mirror_red:{t:'mirror',c:[180,15,15]},mirror_orange:{t:'mirror',c:[230,120,10]},mirror_green:{t:'mirror',c:[10,130,45]},mirror_blue:{t:'mirror',c:[15,50,190]},mirror_purple:{t:'mirror',c:[110,20,180]},mirror_pink:{t:'mirror',c:[190,40,110]},
    brushed_stainless:{t:'brushed',c:[175,178,182]},brushed_gold:{t:'brushed',c:[185,155,55]},carbon_fiber:{t:'carbon'},
    mf_black:{t:'flake',c:[20,20,24]},mf_silver:{t:'flake',c:[180,185,190]},mf_red:{t:'flake',c:[170,10,15]},mf_gold:{t:'flake',c:[200,170,20]},mf_green:{t:'flake',c:[10,150,40]},mf_blue:{t:'flake',c:[15,40,180]},mf_purple:{t:'flake',c:[110,20,170]},mf_pink:{t:'flake',c:[220,80,150]}
  };
  var GROUPS = [
    ['SOLID', ['red','white','gloss_black','matte_black','gray','maroon','orange','yellow','lime_green','green','blue','purple','pink','brown']],
    ['MIRROR', ['mirror_red','mirror_silver','mirror_gold','mirror_rosegold','mirror_orange','mirror_green','mirror_blue','mirror_purple','mirror_pink']],
    ['PATTERNS', ['carbon_fiber','brushed_stainless','brushed_gold']],
    ['METAL FLAKE', ['mf_red','mf_black','mf_silver','mf_gold','mf_green','mf_blue','mf_purple','mf_pink']]
  ];
  var NAMES = {gloss_black:'Gloss Black',matte_black:'Matte Black',gray:'Gray',white:'White',maroon:'Maroon',red:'Red',orange:'Orange',yellow:'Yellow',lime_green:'Lime Green',green:'Green',blue:'Blue',purple:'Purple',pink:'Pink',brown:'Brown',mirror_gold:'Mirror Gold',mirror_silver:'Mirror Silver',mirror_rosegold:'Mirror Rosegold',mirror_red:'Mirror Red',mirror_orange:'Mirror Orange',mirror_green:'Mirror Green',mirror_blue:'Mirror Blue',mirror_purple:'Mirror Purple',mirror_pink:'Mirror Pink',brushed_stainless:'Brushed Stainless',brushed_gold:'Brushed Gold',carbon_fiber:'Carbon Fiber',mf_black:'Flake Black',mf_silver:'Flake Silver',mf_red:'Flake Red',mf_gold:'Flake Gold',mf_green:'Flake Green',mf_blue:'Flake Blue',mf_purple:'Flake Purple',mf_pink:'Flake Pink'};
  var FAMILIES = {
    bold:{family:'ACC Bold',caps:true}, lightning:{family:'ACC Lightning',caps:true},
    aggressive:{family:'ACC Aggressive',caps:true}, script:{family:'ACC Script',caps:false},
    electric:{family:'ACC Electric',caps:true}, ice:{family:'ACC Ice',caps:true},
    oem:{family:'ACC OEM',caps:true}
  };

  function clp(v){return Math.max(0,Math.min(255,Math.round(v)));}
  function prevCol(k){var f=F[k];if(!f)return '#000';if(f.t==='carbon')return '#222';return 'rgb('+f.c[0]+','+f.c[1]+','+f.c[2]+')';}

  function genTex(k,w,h){var c=document.createElement('canvas');c.width=w;c.height=h;var x=c.getContext('2d');var f=F[k];if(!f)f=F.gloss_black;var r,g,b;if(f.c){r=f.c[0];g=f.c[1];b=f.c[2];}
    if(f.t==='solid'){x.fillStyle='rgb('+r+','+g+','+b+')';x.fillRect(0,0,w,h);var gl=x.createLinearGradient(0,0,w*0.6,h*0.4);gl.addColorStop(0,'rgba(255,255,255,0.08)');gl.addColorStop(0.5,'rgba(255,255,255,0)');gl.addColorStop(1,'rgba(0,0,0,0.05)');x.fillStyle=gl;x.fillRect(0,0,w,h);}
    else if(f.t==='matte'){x.fillStyle='rgb('+r+','+g+','+b+')';x.fillRect(0,0,w,h);var id=x.getImageData(0,0,w,h),d=id.data;for(var i=0;i<d.length;i+=4){var n=(Math.random()-0.5)*14;d[i]=clp(d[i]+n);d[i+1]=clp(d[i+1]+n);d[i+2]=clp(d[i+2]+n);}x.putImageData(id,0,0);}
    else if(f.t==='mirror'){x.fillStyle='rgb('+r+','+g+','+b+')';x.fillRect(0,0,w,h);var mg=x.createLinearGradient(0,0,w*0.7,h);mg.addColorStop(0,'rgba(255,255,255,0.03)');mg.addColorStop(0.2,'rgba(255,255,255,0.35)');mg.addColorStop(0.32,'rgba(255,255,255,0.55)');mg.addColorStop(0.42,'rgba(255,255,255,0.15)');mg.addColorStop(0.55,'rgba(0,0,0,0.08)');mg.addColorStop(0.7,'rgba(255,255,255,0.18)');mg.addColorStop(1,'rgba(0,0,0,0.12)');x.fillStyle=mg;x.fillRect(0,0,w,h);var eg=x.createLinearGradient(0,0,0,h);eg.addColorStop(0,'rgba(0,0,0,0.18)');eg.addColorStop(0.25,'rgba(0,0,0,0)');eg.addColorStop(0.75,'rgba(0,0,0,0)');eg.addColorStop(1,'rgba(0,0,0,0.22)');x.fillStyle=eg;x.fillRect(0,0,w,h);}
    else if(f.t==='brushed'){var bg2=x.createLinearGradient(0,0,0,h);bg2.addColorStop(0,'rgb('+(r-15)+','+(g-15)+','+(b-15)+')');bg2.addColorStop(0.2,'rgb('+(r+15)+','+(g+15)+','+(b+15)+')');bg2.addColorStop(0.45,'rgb('+(r-20)+','+(g-20)+','+(b-20)+')');bg2.addColorStop(0.65,'rgb('+(r+10)+','+(g+10)+','+(b+10)+')');bg2.addColorStop(1,'rgb('+r+','+g+','+b+')');x.fillStyle=bg2;x.fillRect(0,0,w,h);var id2=x.getImageData(0,0,w,h),d2=id2.data;for(var y2=0;y2<h;y2++){var rs2=(Math.random()-0.5)*25;for(var xi=0;xi<w;xi++){var idx=(y2*w+xi)*4;var st=Math.sin(xi*0.25+y2*0.015)*10+(Math.random()-0.5)*18+rs2*0.3;d2[idx]=clp(d2[idx]+st);d2[idx+1]=clp(d2[idx+1]+st);d2[idx+2]=clp(d2[idx+2]+st);}}x.putImageData(id2,0,0);var sp=x.createLinearGradient(0,0,w,h*0.35);sp.addColorStop(0,'rgba(255,255,255,0)');sp.addColorStop(0.4,'rgba(255,255,255,0.1)');sp.addColorStop(0.6,'rgba(255,255,255,0)');x.fillStyle=sp;x.fillRect(0,0,w,h);}
    else if(f.t==='carbon'){x.fillStyle='#1a1a1e';x.fillRect(0,0,w,h);var cs=8;for(var cy2=0;cy2<h+cs;cy2+=cs)for(var cx2=0;cx2<w+cs;cx2+=cs){var ev=((Math.floor(cx2/cs)+Math.floor(cy2/cs))%2===0);if(ev){x.fillStyle='rgba(40,40,44,0.9)';x.fillRect(cx2,cy2,cs/2,cs/2);x.fillRect(cx2+cs/2,cy2+cs/2,cs/2,cs/2);x.fillStyle='rgba(25,25,28,0.9)';x.fillRect(cx2+cs/2,cy2,cs/2,cs/2);x.fillRect(cx2,cy2+cs/2,cs/2,cs/2);}else{x.fillStyle='rgba(35,35,40,0.9)';x.fillRect(cx2,cy2,cs/2,cs/2);x.fillRect(cx2+cs/2,cy2+cs/2,cs/2,cs/2);x.fillStyle='rgba(22,22,26,0.9)';x.fillRect(cx2+cs/2,cy2,cs/2,cs/2);x.fillRect(cx2,cy2+cs/2,cs/2,cs/2);}}var cg=x.createLinearGradient(0,0,w*0.5,h*0.5);cg.addColorStop(0,'rgba(255,255,255,0.06)');cg.addColorStop(0.5,'rgba(255,255,255,0)');cg.addColorStop(1,'rgba(0,0,0,0.05)');x.fillStyle=cg;x.fillRect(0,0,w,h);}
    else if(f.t==='flake'){x.fillStyle='rgb('+r+','+g+','+b+')';x.fillRect(0,0,w,h);var nf=Math.round(w*h*0.012);for(var i2=0;i2<nf;i2++){var fx=Math.random()*w,fy=Math.random()*h,br2=0.3+Math.random()*0.7,sz=0.5+Math.random()*1.8;var fr=clp(r+(255-r)*br2*0.7),fg=clp(g+(255-g)*br2*0.7),fb=clp(b+(255-b)*br2*0.7);x.fillStyle='rgba('+fr+','+fg+','+fb+','+(0.4+br2*0.6)+')';x.beginPath();x.arc(fx,fy,sz,0,Math.PI*2);x.fill();}var bf2=Math.round(nf*0.08);for(var i3=0;i3<bf2;i3++){x.fillStyle='rgba(255,255,255,'+(0.15+Math.random()*0.35)+')';x.beginPath();x.arc(Math.random()*w,Math.random()*h,1+Math.random()*2,0,Math.PI*2);x.fill();}var fg2=x.createRadialGradient(w*0.35,h*0.35,0,w*0.5,h*0.5,w*0.6);fg2.addColorStop(0,'rgba(255,255,255,0.06)');fg2.addColorStop(1,'rgba(0,0,0,0.12)');x.fillStyle=fg2;x.fillRect(0,0,w,h);}
    return c;}

  function drawGrille(ctx,w,h){ctx.fillStyle='#1a1a1e';ctx.fillRect(0,0,w,h);var gr=ctx.createLinearGradient(0,0,0,h);gr.addColorStop(0,'rgba(40,40,48,0.6)');gr.addColorStop(0.3,'rgba(20,20,24,0.2)');gr.addColorStop(0.7,'rgba(20,20,24,0.2)');gr.addColorStop(1,'rgba(10,10,14,0.6)');ctx.fillStyle=gr;ctx.fillRect(0,0,w,h);var cW2=22,cH2=17;ctx.strokeStyle='rgba(60,60,68,0.9)';ctx.lineWidth=1.8;var ro,co,ox,cx3,cy3;for(ro=-1;ro<h/cH2+1;ro++)for(co=-1;co<w/cW2+1;co++){ox=(ro%2)*(cW2/2);cx3=co*cW2+ox;cy3=ro*cH2;ctx.beginPath();ctx.moveTo(cx3,cy3-cH2/2);ctx.lineTo(cx3+cW2/2,cy3);ctx.lineTo(cx3,cy3+cH2/2);ctx.lineTo(cx3-cW2/2,cy3);ctx.closePath();ctx.stroke();ctx.fillStyle='rgba(0,0,0,0.3)';var s=0.55;ctx.beginPath();ctx.moveTo(cx3,cy3-cH2/2*s);ctx.lineTo(cx3+cW2/2*s,cy3);ctx.lineTo(cx3,cy3+cH2/2*s);ctx.lineTo(cx3-cW2/2*s,cy3);ctx.closePath();ctx.fill();}ctx.strokeStyle='rgba(90,90,100,0.3)';ctx.lineWidth=0.5;for(ro=-1;ro<h/cH2+1;ro++)for(co=-1;co<w/cW2+1;co++){ox=(ro%2)*(cW2/2);cx3=co*cW2+ox;cy3=ro*cH2;ctx.beginPath();ctx.moveTo(cx3,cy3-cH2/2+1);ctx.lineTo(cx3+cW2/2-1,cy3);ctx.stroke();}ctx.fillStyle='rgba(35,35,42,0.4)';for(var y=0;y<h;y+=Math.round(h/5))ctx.fillRect(0,y-2,w,4);var rs3=Math.round(w/8);for(var i=0;i<9;i++){dR(ctx,rs3*i+rs3/2,14);dR(ctx,rs3*i+rs3/2,h-14);}var vi=ctx.createRadialGradient(w/2,h/2,w*0.2,w/2,h/2,w*0.7);vi.addColorStop(0,'rgba(0,0,0,0)');vi.addColorStop(1,'rgba(0,0,0,0.5)');ctx.fillStyle=vi;ctx.fillRect(0,0,w,h);}
  function dR(ctx,x,y){ctx.beginPath();ctx.arc(x,y,3.5,0,Math.PI*2);ctx.fillStyle='rgba(50,50,58,0.9)';ctx.fill();ctx.strokeStyle='rgba(80,80,90,0.5)';ctx.lineWidth=0.8;ctx.stroke();ctx.beginPath();ctx.arc(x-1,y-1,1.2,0,Math.PI*2);ctx.fillStyle='rgba(120,120,130,0.4)';ctx.fill();}

  function Renderer(canvas,w,h){
    this.CW=w;this.CH=h;canvas.width=w;canvas.height=h;
    this.dx=canvas.getContext('2d');
    function mk(){var c=document.createElement('canvas');c.width=w;c.height=h;return c;}
    this.maskC=mk();this.maskCx=this.maskC.getContext('2d',{willReadFrequently:true});
    this.shadC=mk();this.shadCx=this.shadC.getContext('2d');
    this.bgLC=mk();this.bgLCx=this.bgLC.getContext('2d');
    this.txtLC=mk();this.txtLCx=this.txtLC.getContext('2d');
    this.grilleC=mk();drawGrille(this.grilleC.getContext('2d'),w,h);
  }
  Renderer.prototype.buildTextMasks=function(text,family){
    var CW=this.CW,CH=this.CH,mx=this.maskCx;
    var padX=Math.round(CW*0.08),padY=Math.round(CH*0.16),maxW=CW-padX*2,maxH=CH-padY*2;
    mx.font='200px "'+family+'"';var testM=mx.measureText(text);
    var scW=maxW/Math.max(testM.width,1),scH=maxH/200;
    var fontSize=Math.floor(200*Math.min(scW,scH)*0.85);fontSize=Math.max(36,Math.min(fontSize,CH*0.62));
    var font=fontSize+'px "'+family+'"';var strokeW=Math.max(fontSize*0.2,10);
    mx.font=font;var tm=mx.measureText(text);var cx=CW/2;
    var ascent=tm.actualBoundingBoxAscent||fontSize*0.75;var descent=tm.actualBoundingBoxDescent||fontSize*0.15;
    var cy=CH/2+ascent/2-descent/2;
    mx.clearRect(0,0,CW,CH);mx.font=font;mx.textAlign='center';mx.textBaseline='alphabetic';
    mx.lineWidth=strokeW;mx.lineJoin='round';mx.strokeStyle='#fff';mx.strokeText(text,cx,cy);mx.fillStyle='#fff';mx.fillText(text,cx,cy);
    var bgData=mx.getImageData(0,0,CW,CH);
    mx.clearRect(0,0,CW,CH);mx.font=font;mx.textAlign='center';mx.textBaseline='alphabetic';mx.fillStyle='#fff';mx.fillText(text,cx,cy);
    var txtData=mx.getImageData(0,0,CW,CH);
    var bgA=new Float32Array(CW*CH),txtA=new Float32Array(CW*CH);
    for(var i=0;i<bgA.length;i++){bgA[i]=bgData.data[i*4+3]/255;txtA[i]=txtData.data[i*4+3]/255;}
    return {bg:bgA,txt:txtA};
  };
  Renderer.prototype.applyTex=function(tCtx,mask,key){
    var w=this.CW,h=this.CH;var tex=genTex(key,w,h);var mid=tCtx.createImageData(w,h);
    for(var i=0;i<mask.length;i++){mid.data[i*4]=255;mid.data[i*4+1]=255;mid.data[i*4+2]=255;mid.data[i*4+3]=Math.round(mask[i]*255);}
    tCtx.clearRect(0,0,w,h);tCtx.putImageData(mid,0,0);
    tCtx.globalCompositeOperation='source-in';tCtx.drawImage(tex,0,0);tCtx.globalCompositeOperation='source-over';
  };
  Renderer.prototype.render=function(text,family,faceKey,backKey,placeholder){
    var CW=this.CW,CH=this.CH,dx=this.dx;
    dx.clearRect(0,0,CW,CH);dx.drawImage(this.grilleC,0,0);
    if(!text){dx.fillStyle='rgba(255,255,255,0.14)';dx.font=Math.round(CH*0.055)+'px system-ui,sans-serif';dx.textAlign='center';dx.fillText(placeholder||'Type your text to preview',CW/2,CH/2);return;}
    var masks=this.buildTextMasks(text,family);if(!masks)return;
    this.shadCx.clearRect(0,0,CW,CH);
    var sid=this.shadCx.createImageData(CW,CH);
    for(var i=0;i<masks.bg.length;i++){sid.data[i*4]=0;sid.data[i*4+1]=0;sid.data[i*4+2]=0;sid.data[i*4+3]=Math.round(masks.bg[i]*255);}
    this.shadCx.putImageData(sid,0,0);
    dx.save();dx.filter='blur(10px)';dx.globalAlpha=0.5;dx.drawImage(this.shadC,5,9);dx.restore();
    this.applyTex(this.bgLCx,masks.bg,backKey);dx.drawImage(this.bgLC,0,0);
    this.applyTex(this.txtLCx,masks.txt,faceKey);dx.drawImage(this.txtLC,0,0);
  };

  /* ---- boot each builder section on the page ---- */
  function initBuilder(root){
    var cfgEl=root.querySelector('[data-builder-config]');if(!cfgEl)return;
    var cfg;try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}
    var fonts=(cfg.fonts||[]).map(function(f){
      var fam=FAMILIES[f.key]||FAMILIES.bold;
      return {key:f.key,family:fam.family,caps:fam.caps,label:f.label||f.key,url:f.url||'',variants:f.variants||[]};
    });
    if(!fonts.length)return;

    var canvas=root.querySelector('[data-badge-canvas]');
    var small=window.innerWidth<700;
    var R=new Renderer(canvas, small?900:1440, small?420:560);

    var state={text:cfg.defaultText||'ATOMIC',font:fonts[0],face:'red',back:'gloss_black',layer:'face',finish:0,mount:'VHB'};
    var attract=cfg.attract!==false,attractTimer=null,attractIdx=1;
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SCENES=[
      {t:cfg.defaultText||'ATOMIC',f:'bold',face:'red',back:'gloss_black'},
      {t:'BUILT BY HAND',f:'oem',face:'mirror_silver',back:'matte_black'},
      {t:'SEND IT',f:'aggressive',face:'mf_red',back:'gloss_black'},
      {t:'Old School',f:'script',face:'mirror_gold',back:'carbon_fiber'},
      {t:'HIGH VOLTAGE',f:'electric',face:'yellow',back:'gloss_black'},
      {t:'YOUR TEXT',f:'lightning',face:'white',back:'red'},
      {t:'ICE COLD',f:'ice',face:'mirror_blue',back:'gloss_black'}
    ].filter(function(s){return fonts.some(function(f){return f.key===s.f;});});

    var sweep=root.querySelector('[data-sweep]');
    var attractTag=root.querySelector('[data-attract-tag]');
    var input=root.querySelector('[data-badge-input]');
    var charEl=root.querySelector('[data-char-count]');
    var cta=root.querySelector('[data-badge-cta]');
    var ctaText=root.querySelector('[data-cta-text]');
    var pdpLink=root.querySelector('[data-pdp-link]');
    var msgEl=root.querySelector('[data-badge-msg]');
    var selFont=root.querySelector('[data-sel-font]');
    var layerBtns=root.querySelectorAll('[data-layer]');
    var finishTabs=root.querySelector('[data-finish-tabs]');
    var swArea=root.querySelector('[data-swatch-area]');
    var colorName=root.querySelector('[data-color-name]');

    function fontByKey(k){for(var i=0;i<fonts.length;i++)if(fonts[i].key===k)return fonts[i];return fonts[0];}
    function displayText(){var t=state.text.trim();if(!t)return '';return state.font.caps?t.toUpperCase():t;}
    function groupOf(key){for(var i=0;i<GROUPS.length;i++)if(GROUPS[i][1].indexOf(key)>-1)return i;return 0;}

    /* ---- compact picker: layer toggle + finish tabs + one swatch row ---- */
    function buildFinishTabs(){
      finishTabs.innerHTML='';
      GROUPS.forEach(function(g,i){
        var b=document.createElement('button');b.type='button';b.className='abb-tab';
        b.textContent=g[0];b.setAttribute('aria-pressed',i===state.finish?'true':'false');
        b.addEventListener('click',function(){stopAttract();state.finish=i;buildSwatchRow();syncPicker();});
        finishTabs.appendChild(b);
      });
    }
    function buildSwatchRow(){
      swArea.innerHTML='';
      GROUPS[state.finish][1].forEach(function(k){
        var b=document.createElement('button');b.type='button';b.className='abb-sw abb-sw-'+F[k].t;
        b.style.background=prevCol(k);b.title=NAMES[k];b.setAttribute('aria-label',NAMES[k]);
        b.dataset.k=k;b.setAttribute('aria-pressed','false');
        b.addEventListener('click',function(){stopAttract();state[state.layer]=k;render();});
        swArea.appendChild(b);
      });
    }
    function syncPicker(){
      layerBtns.forEach(function(b){
        var l=b.dataset.layer;
        b.setAttribute('aria-pressed',l===state.layer?'true':'false');
        var chip=b.querySelector('[data-layer-chip]');if(chip)chip.style.background=prevCol(state[l]);
        var nm=b.querySelector('[data-layer-name]');if(nm)nm.textContent=NAMES[state[l]];
      });
      finishTabs.querySelectorAll('.abb-tab').forEach(function(t,i){t.setAttribute('aria-pressed',i===state.finish?'true':'false');});
      swArea.querySelectorAll('.abb-sw').forEach(function(s){s.setAttribute('aria-pressed',s.dataset.k===state[state.layer]?'true':'false');});
      if(colorName)colorName.textContent=NAMES[state[state.layer]];
    }
    layerBtns.forEach(function(b){
      b.addEventListener('click',function(){
        stopAttract();state.layer=b.dataset.layer;
        state.finish=groupOf(state[state.layer]);
        buildSwatchRow();syncPicker();
      });
    });
    root.querySelectorAll('[data-mount]').forEach(function(b){
      b.addEventListener('click',function(){
        stopAttract();state.mount=b.dataset.mount;
        root.querySelectorAll('[data-mount]').forEach(function(x){x.setAttribute('aria-pressed',x===b?'true':'false');});
      });
    });

    function currentVariant(){
      var vs=state.font.variants||[];
      if(!vs.length)return null;
      for(var i=0;i<vs.length;i++)if(/one/i.test(vs[i].title)&&vs[i].available)return vs[i];
      for(var j=0;j<vs.length;j++)if(vs[j].available)return vs[j];
      return vs[0];
    }
    function updateCta(){
      var t=displayText();
      if(ctaText)ctaText.textContent=t?('BUILD "'+t+'"'):(cfg.ctaLabel||'BUILD MY BADGE');
      var base=state.font.url||cfg.fallbackUrl||'/collections/all';
      var joiner=base.indexOf('?')>-1?'&':'?';
      var href=base+joiner+'text='+encodeURIComponent(t);
      if(pdpLink)pdpLink.setAttribute('href',href);
      if(cta)cta.setAttribute('href',href);
    }
    function render(){
      if(input)input.style.textTransform=state.font.caps?'uppercase':'none';
      R.render(displayText(),state.font.family,state.face,state.back,cfg.placeholder||'Type your text to preview');
      if(sweep&&!reduced){sweep.classList.remove('go');void sweep.offsetWidth;sweep.classList.add('go');}
      if(selFont)selFont.textContent=state.font.label;
      root.querySelectorAll('[data-font-chip]').forEach(function(c){c.setAttribute('aria-pressed',c.dataset.key===state.font.key?'true':'false');});
      syncPicker();updateCta();
    }
    function stopAttract(){
      if(!attract)return;attract=false;clearInterval(attractTimer);
      if(attractTag)attractTag.classList.add('off');
      state.text=input?input.value||state.text:state.text;
      render();
    }
    function attractStep(){
      var s=SCENES[attractIdx%SCENES.length];attractIdx++;
      state.text=s.t;state.font=fontByKey(s.f);state.face=s.face;state.back=s.back;
      state.finish=groupOf(state[state.layer]);
      if(input)input.value=s.t;
      if(charEl)charEl.textContent=s.t.length+'/16';
      buildSwatchRow();render();
    }

    /* font chips */
    var chipWrap=root.querySelector('[data-font-chips]');
    fonts.forEach(function(f){
      var b=document.createElement('button');b.type='button';b.className='abb-font-chip';
      b.textContent=f.label;b.style.fontFamily='"'+f.family+'"';b.dataset.key=f.key;
      b.setAttribute('data-font-chip','');b.setAttribute('aria-pressed','false');
      b.addEventListener('click',function(){stopAttract();state.font=f;render();});
      chipWrap.appendChild(b);
    });

    if(input){
      input.addEventListener('input',function(){stopAttract();state.text=input.value;if(charEl)charEl.textContent=input.value.length+'/16';render();});
      input.addEventListener('focus',stopAttract);
    }
    document.querySelectorAll('[data-strip-font]').forEach(function(t){
      t.addEventListener('click',function(e){
        if(!fonts.some(function(f){return f.key===t.dataset.stripFont;}))return;
        e.preventDefault();stopAttract();state.font=fontByKey(t.dataset.stripFont);render();
        root.scrollIntoView({behavior:reduced?'auto':'smooth',block:'center'});
        if(input)input.focus({preventScroll:true});
      });
    });

    /* ---- real add-to-cart: same endpoint + properties as the product builders ---- */
    function setMsg(m){if(msgEl)msgEl.textContent=m||'';}
    if(cta){
      cta.addEventListener('click',function(e){
        stopAttract();
        var t=displayText();
        var v=currentVariant();
        if(!v){return;} /* no product assigned -> follow the link (with ?text=) */
        e.preventDefault();
        if(!t){setMsg('Type your text first.');if(input)input.focus();return;}
        setMsg('');
        cta.classList.add('is-busy');
        if(ctaText)ctaText.textContent='ADDING...';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:v.id,quantity:1,properties:{
            'Custom Text':t,
            'Text Color':NAMES[state.face],
            'Background Color':NAMES[state.back],
            'Quantity Selected':'1 Badge',
            'Mounting':state.mount==='Studs'?'Studs (Grille Mount)':'VHB Tape (Flat Surface)'
          }}]})
        }).then(function(r){return r.json();}).then(function(data){
          if(data.items||data.id){
            if(ctaText)ctaText.textContent='ADDED! OPENING CART...';
            window.location.href='/cart';
          }else{
            setMsg(data.message||data.description||'Error adding to cart');
            cta.classList.remove('is-busy');updateCta();
          }
        }).catch(function(err){
          setMsg('Error: '+err.message);
          cta.classList.remove('is-busy');updateCta();
        });
      });
    }

    buildFinishTabs();buildSwatchRow();
    render();
    if(attract&&!reduced&&SCENES.length>1){
      attractTimer=setInterval(attractStep,2800);
      setTimeout(attractStep,900);
    }else if(attractTag){attractTag.classList.add('off');}
  }

  function boot(){
    var roots=document.querySelectorAll('[data-atomic-builder]');
    if(!roots.length)return;
    var famSet={};
    roots.forEach(function(r){
      var cfgEl=r.querySelector('[data-builder-config]');
      if(!cfgEl)return;
      try{JSON.parse(cfgEl.textContent).fonts.forEach(function(f){var fam=FAMILIES[f.key];if(fam)famSet[fam.family]=1;});}catch(e){}
    });
    var loads=Object.keys(famSet).map(function(fam){return document.fonts.load('80px "'+fam+'"','ATOMIC abc');});
    Promise.all(loads).then(function(){roots.forEach(initBuilder);}).catch(function(){roots.forEach(initBuilder);});
  }
  if(document.readyState==='complete')boot();
  else window.addEventListener('load',boot);
})();
